export default "__VITE_ASSET__31WQMuAHGQn67ooKheJ_4g__"